import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-78312270"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "image-code"
};
var _hoisted_2 = {
  class: "vcode-suffix"
};
var _hoisted_3 = /*#__PURE__*/_createTextVNode("找回账号和密码");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_input = _resolveComponent("a-input");
  var _component_a_form_item = _resolveComponent("a-form-item");
  var _component_ImageCode = _resolveComponent("ImageCode");
  var _component_VCode = _resolveComponent("VCode");
  var _component_a_button = _resolveComponent("a-button");
  var _component_a_form = _resolveComponent("a-form");
  return _openBlock(), _createBlock(_component_a_form, {
    ref: "formRef",
    rules: _ctx.formRules,
    model: _ctx.formState,
    "label-col": _ctx.labelCol,
    "wrapper-col": _ctx.wrapperCol
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_form_item, {
        label: "",
        name: "phone",
        class: "item-mobile"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_input, {
            size: "large",
            maxlength: 11,
            value: _ctx.formState.phone,
            "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
              return _ctx.formState.phone = $event;
            }),
            placeholder: "请输入手机号"
          }, null, 8, ["value"])];
        }),
        _: 1
      }), _createVNode(_component_a_form_item, {
        label: "",
        name: "imageCode",
        class: "item-image"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_input, {
            size: "large",
            maxlength: 5,
            value: _ctx.formState.imageCode,
            "onUpdate:value": _cache[2] || (_cache[2] = function ($event) {
              return _ctx.formState.imageCode = $event;
            }),
            placeholder: "请输入图片验证码",
            autoComplete: "off"
          }, {
            suffix: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_1, [_createVNode(_component_ImageCode, {
                onClearCode: _cache[1] || (_cache[1] = function ($event) {
                  return _ctx.formState.imageCode = '';
                })
              })])];
            }),
            _: 1
          }, 8, ["value"])];
        }),
        _: 1
      }), _createVNode(_component_a_form_item, {
        label: "",
        name: "code",
        class: "item-code"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_input, {
            size: "large",
            maxlength: 6,
            value: _ctx.formState.code,
            "onUpdate:value": _cache[4] || (_cache[4] = function ($event) {
              return _ctx.formState.code = $event;
            }),
            placeholder: "请输入短信验证码",
            onFocus: _ctx.onShowImgCode
          }, {
            suffix: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_2, [_createVNode(_component_VCode, {
                phone: _ctx.formState.phone,
                imgCode: _ctx.formState.imageCode,
                onClearCode: _cache[3] || (_cache[3] = function ($event) {
                  return _ctx.formState.imageCode = '';
                })
              }, null, 8, ["phone", "imgCode"])])];
            }),
            _: 1
          }, 8, ["value", "onFocus"])];
        }),
        _: 1
      }), _createVNode(_component_a_form_item, {
        label: ""
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_button, {
            size: "large",
            maxlength: 6,
            class: "item-button",
            type: "primary",
            shape: "round",
            block: "",
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(function () {
              return [_hoisted_3];
            }),
            _: 1
          }, 8, ["onClick"])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["rules", "model", "label-col", "wrapper-col"]);
}